import { adminUsersByIdLinksPasswordResetGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { adminUsersByIdLinksPasswordResetSendReducers, adminUsersByIdLinksPasswordResetSendWatchers } from './send';

export const adminUsersByIdLinksPasswordResetReducers = combineReducers({
	get: adminUsersByIdLinksPasswordResetGetSlice.asyncReducers,
	send: adminUsersByIdLinksPasswordResetSendReducers
});

export const adminUsersByIdLinksPasswordResetWatchers = combineAllWatchers([
	adminUsersByIdLinksPasswordResetGetSlice.asyncWatchers,
	adminUsersByIdLinksPasswordResetSendWatchers
]);
